import {remCalc} from '../../_utils'

export default {
    baseStyle: () => {
        const remCalc6 = remCalc(6)

        return {
            '.chakra-ui-light': {
                '.gigya-password-strength-bubble .gig-balloon-frame': {
                    background: 'white',
                    border: 0, //'small',
                    // borderStyle: 'solid',
                    // borderColor: 'border.light',
                    borderRadius: remCalc(2),
                    boxShadow: `0 0 ${remCalc6} 0 rgba(0, 0, 0, 0.15)`,
                    padding: remCalc(16),
                },
                '.gigya-password-strength-bubble .gig-balloon-nub, .gigya-password-strength-bubble .gig-balloon-nub-up, .gigya-password-strength-bubble .gig-balloon-nub-right, .gigya-password-strength-bubble .gig-balloon-nub-down':
                    {
                        filter: 'contrast(200%) brightness(150%)',
                        marginLeft: 'calc(50% - 16px)',
                    },
                '.gigya-password-strength-bubble .gig-balloon-frame .gigya-passwordStrength-bar': {
                    display: 'none',
                },
                '.gigya-passwordStrength-text:not(.gigya-passwordStrength-text .gigya-passwordStrength-text)':
                    {
                        paddingBottom: remCalc(8),
                    },
                '.gigya-passwordStrength-text, div.gigya-passwordStrength-text-requirements': {
                    textAlign: 'left',
                },
                'span.gigya-passwordStrength-scoreText': {
                    marginLeft: 0,
                },
                '.gigya-style-modern #gigya-screen-dialog-page-overlay': {
                    opacity: 0.75,
                },
            },
        }
    },
}
